import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 500);
    });
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/categories",
      name: "categories",
      component: () =>
        import(/* webpackChunkName: "categories" */ "./views/Categories.vue"),
    },
    {
      path: "/shootings",
      name: "shootings",
      component: () =>
        import(/* webpackChunkName: "shootings" */ "./views/Shootings.vue"),
    },
    {
      path: "/category/:id",
      name: "category",
      component: () =>
        import(/* webpackChunkName: "category" */ "./views/Category.vue"),
    },
    {
      path: "/shooting/:id",
      name: "shooting",
      component: () =>
        import(/* webpackChunkName: "shooting" */ "./views/Shooting.vue"),
    },
    {
      path: "/contact",
      name: "contact",
      component: () =>
        import(/* webpackChunkName: "contact" */ "./views/Contact.vue"),
    },
    {
      path: "/legal-mention",
      name: "legal-mention",
      component: () =>
        import(
          /* webpackChunkName: "legalMention" */ "./views/LegalMention.vue"
        ),
    },
    {
      path: "*",
      name: "not-found",
      component: () =>
        import(/* webpackChunkName: "notFound" */ "./views/NotFound.vue"),
    },
  ],
});
